/**
 * Custom Mega Menu — Vanilla JS
 * Handles hover/click interactions for Shop, Collections, and Explore mega menus.
 * Also handles interactive category switching and mobile accordion toggle.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 250;
  var MOBILE_BP = 1024;

  /* ---- Desktop Mega Menu ---- */
  function initDesktopMegas() {
    var triggers = document.querySelectorAll('[data-custom-mega-trigger]');
    var overlay = document.querySelector('.custom-mega-overlay');

    triggers.forEach(function (trigger) {
      var targetId = trigger.getAttribute('data-custom-mega-trigger');
      var panel = document.getElementById(targetId);
      if (!panel) return;

      var openTimer = null;
      var closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        closeAllExcept(targetId);
        openTimer = setTimeout(function () {
          panel.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          if (overlay) overlay.classList.add('is-visible');
        }, OPEN_DELAY);
      }

      function close() {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          panel.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          if (overlay) {
            var anyOpen = document.querySelector('.custom-mega-wrap.is-open');
            if (!anyOpen) overlay.classList.remove('is-visible');
          }
        }, CLOSE_DELAY);
      }

      function keepOpen() {
        clearTimeout(closeTimer);
      }

      // Position Explore dropdown under its trigger
      function positionExplore() {
        if (targetId === 'CustomMegaExplore') {
          var rect = trigger.getBoundingClientRect();
          var sectionEl = trigger.closest('.header-section');
          var sectionRect = sectionEl ? sectionEl.getBoundingClientRect() : { left: 0 };
          panel.style.left = (rect.left - sectionRect.left) + 'px';
          panel.style.width = 'max-content';
        }
      }

      // Hover events (desktop)
      trigger.addEventListener('mouseenter', function () {
        if (window.innerWidth >= MOBILE_BP) { positionExplore(); open(); }
      });
      trigger.addEventListener('mouseleave', function () {
        if (window.innerWidth >= MOBILE_BP) close();
      });
      panel.addEventListener('mouseenter', function () {
        if (window.innerWidth >= MOBILE_BP) keepOpen();
      });
      panel.addEventListener('mouseleave', function () {
        if (window.innerWidth >= MOBILE_BP) close();
      });

      // Click toggle (touch / accessibility)
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open')) {
          panel.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          if (overlay) overlay.classList.remove('is-visible');
        } else {
          positionExplore();
          closeAllExcept(null);
          panel.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          if (overlay) overlay.classList.add('is-visible');
        }
      });

      // Keyboard: Escape closes
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
    });

    // Overlay click closes all
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeAllExcept(null);
      });
    }

    // Close on scroll (debounced)
    var scrollTimer = null;
    window.addEventListener('scroll', function () {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () {
        scrollTimer = null;
        closeAllExcept(null);
      }, 100);
    }, { passive: true });
  }

  function closeAllExcept(exceptId) {
    var overlay = document.querySelector('.custom-mega-overlay');
    document.querySelectorAll('.custom-mega-wrap').forEach(function (p) {
      if (p.id !== exceptId) {
        p.classList.remove('is-open');
      }
    });
    document.querySelectorAll('[data-custom-mega-trigger]').forEach(function (t) {
      if (t.getAttribute('data-custom-mega-trigger') !== exceptId) {
        t.setAttribute('aria-expanded', 'false');
      }
    });
    // Check if any is still open
    var anyOpen = document.querySelector('.custom-mega-wrap.is-open');
    if (!anyOpen && overlay) overlay.classList.remove('is-visible');
  }

  /* ---- Shop category sidebar: hover switches product panels ---- */
  function initCategoryHover() {
    var cats = document.querySelectorAll('[data-custom-mega-cat]');
    var panels = document.querySelectorAll('[data-custom-mega-panel]');

    cats.forEach(function (cat) {
      cat.addEventListener('mouseenter', function () {
        var index = cat.getAttribute('data-custom-mega-cat');

        // Update active category
        cats.forEach(function (c) { c.classList.remove('is-active'); });
        cat.classList.add('is-active');

        // Switch product panel
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        var targetPanel = document.querySelector('[data-custom-mega-panel="' + index + '"]');
        if (targetPanel) targetPanel.classList.add('is-active');
      });

      // Handle click/tap to switch category panel (desktop and mobile)
      cat.addEventListener('click', function () {
        var index = cat.getAttribute('data-custom-mega-cat');
        cats.forEach(function (c) { c.classList.remove('is-active'); });
        cat.classList.add('is-active');
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        var targetPanel = document.querySelector('[data-custom-mega-panel="' + index + '"]');
        if (targetPanel) targetPanel.classList.add('is-active');
      });
    });
  }

  /* ---- Mobile Accordion ---- */
  function initMobileAccordions() {
    var toggles = document.querySelectorAll('.custom-mega-mobile__toggle');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var panel = toggle.nextElementSibling;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';

        // Close all other accordions
        toggles.forEach(function (other) {
          if (other !== toggle) {
            other.setAttribute('aria-expanded', 'false');
            var otherPanel = other.nextElementSibling;
            if (otherPanel) otherPanel.classList.remove('is-open');
          }
        });

        toggle.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.classList.toggle('is-open');
      });
    });
  }

  /* ---- Init ---- */
  function init() {
    initDesktopMegas();
    initCategoryHover();
    initMobileAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
